<div class="d-flex margin-top-20" *ngIf="!isFromDashboard && !showNodata">
    <div class="mr-auto">
        <h2 class="mainhead"><span class="text">{{externalMarketingType?.description}}</span></h2>
    </div>
    <a class="filter btn ml-auto  btn-circle btn-green adduserbtn" [ngClass]="{'disable-link':property.IsDeleted}" href="javascript:void(0);" (click)="onAddOrEdit(ExternalMarketingAdd,'panlestyle')" tooltip='{{"Add " + externalMarketingType?.description}}'><i class="fa fa-plus icon" aria-hidden="true"></i></a>
</div>
<div class="table-responsive" *ngIf="!showNodata">
    <table class="table basictable" datatable [dtOptions]="dtOptions">
        <thead>
          <tr>
            <th *ngIf="!isFromDashboard"  data-orderable="false">Action</th>
            <th [hidden]="hideSource">Source</th>
            <th>Week Start Date</th>
            <th>{{externalMarketingType?.description}}</th>
            <th>Last Modified</th>

          </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let marketing of lstExternalMarketing">
              <tr>
                <td *ngIf="!isFromDashboard">
                  <a [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="marketing.Id > 0" class="blueone quick-edit" tooltip="Edit" href="javascript:void(0);" (click)="onAddOrEdit(ExternalMarketingAdd,'panlestyle',marketing)"><i class="icofont icofont-ui-edit" aria-hidden="true"></i></a>
                  <a [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="marketing.Id > 0" class="remove" tooltip="Remove" href="javascript:void(0);" (click)="removeModel(template,'deletemodal',marketing.Id)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                  <a [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="marketing.Type == 4055 && marketing.LstDocuments != null && marketing.LstDocuments.length > 0 && marketing.LstDocuments[0].Id > 0" (click)="docList(Documents,'panlestyle',marketing)" class="view" href="javascript:void(0);" tooltip="Attachments" ng-reflect-tooltip="Attachments">
                    <i style="font-size:14px;" class="fa fa-paperclip" aria-hidden="true"></i>
                  </a>
                </td>
                <td [hidden]="hideSource">{{marketing.Source != null ? marketing.Source : '-'}}</td>
                <td>{{marketing.FromDate | date: 'MM/dd/yyyy'}} - {{_validationService.addDays(marketing.FromDate , 6) | date: 'MM/dd/yyyy'}}</td>
                <td>{{marketing.Value != null && marketing.Value > 0 ? (marketing.Value | number:0) : '-' }}</td>
                <td>
                  <p>{{marketing.ModifiedDate ? (marketing.ModifiedDate | date: 'MM/dd/yyyy') : "-"}}</p>
                  <p> {{marketing.ModifiedUser ? marketing.ModifiedUser : ""}}</p>
                </td>

              </tr>
            </ng-container>
        </tbody>
        <tfoot>
            <tr *ngIf="lstExternalMarketing?.length == 0 &&!IsLoading">
                <td colspan="4" class="odd no-data-available">
                    <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>


<div class="col-md-12" *ngIf="showNodata">
    <div class="border-div">
        <div class="nodata">
            <p>Data will start populating once property reaches the marketing phase.</p>
        </div>
    </div>
</div>

<ng-template #ExternalMarketingAdd id="modal">
    <app-external-maketing-add [marketingType]="externalMarketingType" [marketing]="marketing" [propertyId]="propertyId" (close)="close()" (save)="save($event)"></app-external-maketing-add>
</ng-template>

<ng-template #template>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete {{externalMarketingType?.description}} ?</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="removeModalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="removeExternalMarketing();removeModalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #Documents>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Attachments</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="docClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group docs-list">
            <ng-container *ngFor="let doc of documentsList; let i= index">
                <p class="file-view-list">
                    <span class="count">{{i + 1}} </span>
                    <a *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">{{doc.Name}}</a>
                    <span style="cursor:none !important" *ngIf="doc.Url == null || doc.Url == undefiend || doc.Url.length == 0">{{doc.Name}}</span>
                    <a style="padding-left:5px" class="ml-auto file-download" *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">
                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                    </a>
                </p>
            </ng-container>
        </div>
    </div>
</ng-template>
